import { Component, Input } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
	selector: 'leo-box',
	templateUrl: "./leo-box.html",
	styles: [require("./leo-box.scss")
]
})
export class LeoBox {
	@Input() pageHeadline: string;
	@Input() headlineCssClass: string;
	@Input() boxHeadline: string;
	@Input() boxHeadlineLink: string[];
	@Input() boxCssClass: string;
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/leo-box/leo-box.component.ts